import React from 'react';

class BtnFilter extends React.Component{
    changeStatus=()=>{
        this.props.changeFilter(this.props.name);
    }
    render(){
        let classNames="btn todo-btn-filter";
        const {label , active}=this.props;
        const style={
            boxShadow: 'none'
        }
        if(active)
            classNames+=" btn-info";
        return(
            <button type="button"
                    onClick={this.changeStatus}
                    style={style}
                    className={classNames}>{label}</button>
        );
    }
}

export default BtnFilter;
